<template>
  <div>
    <div class="background-container">
      <div class="about-title">
        상임위원회 법안처리 현황<span class="about-title-dot"></span>
      </div>
    </div>

    <div class="national-content">
      <div class="national-content-inner">
        <!--  -->
        <div
          class="national-search-bg"
          @click="closeSortList"
          v-if="isSortingListShow"
        ></div>

        <div class="title-wrap">
          <div>
            <span class="national-blue-bar"></span>
            <div class="national-title">상임위원회 법안처리 현황</div>
          </div>
          <!-- <div class="standing-graph-title">
            <div><span class="round blue"></span><span>회부(건)</span></div>
            <div><span class="round red"></span><span>처리율(%)</span></div>
          </div> -->
        </div>
        <MobileScroll />
        <!--  -->
        <div class="canvas-wrap">
          <canvas style="min-width: 700px" id="chart"></canvas>
        </div>
        <!--  -->
        <div class="table-wrap">
          <span class="national-blue-bar sky"></span>
          <span class="national-blue-bar"></span>
          <div class="title-wrap">
            <div class="national-title">상임위원회 법안처리 현황표</div>
            <div class="national-button-wrap">
              <button class="prev-btn" @click="openSortList" type="button">
                {{ selectedLabel
                }}<img
                  class="arrow"
                  :src="
                    isSortingListShow
                      ? require('../assets/img/top-arrow.png')
                      : require('../assets/img/bottom-arrow.png')
                  "
                  alt="화살표"
                />
              </button>
              <ul v-if="isSortingListShow" class="national-search-list">
                <li
                  :class="selectedLabel === '기본 정렬' ? 'selected' : ''"
                  @click="sortList('BASE', '기본 정렬')"
                >
                  기본 정렬<img
                    v-if="selectedLabel === '기본 정렬'"
                    class="selected-img"
                    :src="require('../assets/img/selected.png')"
                    alt="체크아이콘"
                  />
                </li>
                <li
                  :class="selectedLabel === '위원회명' ? 'selected' : ''"
                  @click="sortList('COMMITTEE', '위원회명')"
                >
                  위원회명<img
                    v-if="selectedLabel === '위원회명'"
                    class="selected-img"
                    :src="require('../assets/img/selected.png')"
                    alt="체크아이콘"
                  />
                </li>
                <li
                  :class="selectedLabel === '회부건' ? 'selected' : ''"
                  @click="sortList('REFERRAL', '회부건')"
                >
                  회부건<img
                    v-if="selectedLabel === '회부건'"
                    class="selected-img"
                    :src="require('../assets/img/selected.png')"
                    alt="체크아이콘"
                  />
                </li>
                <li
                  :class="selectedLabel === '처리건' ? 'selected' : ''"
                  @click="sortList('PROCESSING', '처리건')"
                >
                  처리건<img
                    v-if="selectedLabel === '처리건'"
                    class="selected-img"
                    :src="require('../assets/img/selected.png')"
                    alt="체크아이콘"
                  />
                </li>
                <li
                  :class="selectedLabel === '미처리건' ? 'selected' : ''"
                  @click="sortList('UN_PROCESSING', '미처리건')"
                >
                  미처리건<img
                    v-if="selectedLabel === '미처리건'"
                    class="selected-img"
                    :src="require('../assets/img/selected.png')"
                    alt="체크아이콘"
                  />
                </li>
                <li
                  :class="selectedLabel === '처리율' ? 'selected' : ''"
                  @click="sortList('PROCESSING_RATE', '처리율')"
                >
                  처리율<img
                    v-if="selectedLabel === '처리율'"
                    class="selected-img"
                    :src="require('../assets/img/selected.png')"
                    alt="체크아이콘"
                  />
                </li>
              </ul>
            </div>
          </div>
          <!--  -->
          <div class="table-wrap-two">
            <table class="national-table">
              <tr>
                <th>순번</th>
                <th>위원회명</th>
                <th>회부(건)</th>
                <th>처리(건)</th>
                <th>미처리(건)</th>
                <th>처리율(%)</th>
              </tr>
              <tr v-for="(item, index) in renderData" :key="index">
                <!-- 순번 -->
                <td>{{ index + 1 }}</td>
                <!-- 위원원명 -->
                <td>{{ item.CMIT_NM }}</td>
                <!-- 회부건 -->
                <td class="blue">{{ item.RCP_CNT.toLocaleString() }}</td>
                <!-- 처리건 -->
                <td>{{ item.PROC_CNT.toLocaleString() }}</td>
                <!-- 미처리건 -->
                <td>{{ item.RSVT_CNT.toLocaleString() }}</td>
                <!-- 처리율 -->
                <td class="red">{{ item.PROC_RATE }}%</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MobileScroll from "@/components/common/MobileScroll.vue";
import axios from "axios";
import {
  Chart,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  LineController,
} from "chart.js";

const sorting = [
  "국회운영위원회",
  "법제사법위원회",
  "정무위원회",
  "기획재정위원회",
  "교육위원회",
  "과학기술정보방송통신위원회",
  "외교통일위원회",
  "국방위원회",
  "행정안전위원회",
  "문화체육관광위원회",
  "농림축산식품해양수산위원회",
  "산업통상자원중소벤처기업위원회",
  "보건복지위원회",
  "환경노동위원회",
  "국토교통위원회",
  "정보위원회",
  "여성가족위원회",
];

export default {
  name: "StandingCommitteeBill",

  data() {
    return {
      originData: [],
      renderData: [],
      isSortingListShow: false,
      selectedLabel: "기본 정렬",
      chartData: null,
      exceptionListTitle: [
        "본회의",
        "예산결산특별위원회",
        "특위",
        "미확정",
        "총계",
      ],
    };
  },

  mounted() {
    this.getData();
  },

  components: { MobileScroll },

  methods: {
    async getData() {
      try {
        const res = await axios.get(
          process.env.VUE_APP_TRAGET_URL + "/assembly/statistics/committee"
        );
        if (typeof res.data.list !== "undefined") {
          this.originData = [...res.data.list].filter((item) => {
            return !this.exceptionListTitle.includes(item.CMIT_NM);
          });

          this.renderData = [...this.originData].sort((x, y) => {
            const indexX = sorting.indexOf(x.CMIT_NM);
            const indexY = sorting.indexOf(y.CMIT_NM);

            // a 배열에 존재하지 않는 위원회들은 최하위로 배치
            if (indexX === -1) return 1; // x가 없으면 뒤로 보내기
            if (indexY === -1) return -1; // y가 없으면 뒤로 보내기

            return indexX - indexY; // 두 위원회가 a 배열에서 나타나는 순서대로 정렬
          });

          this.setupChartData();
        }
      } catch (exception) {
        console.error(`[getData] - exception ${exception}`);
        alert("데이터 요청에 실패했습니다. 하단 이메일로 문의해주세요.");
      }
    },
    openSortList() {
      this.isSortingListShow = true;
    },
    closeSortList() {
      this.isSortingListShow = false;
    },
    sortList(type, label) {
      this.selectedLabel = label;
      switch (type) {
        case "COMMITTEE":
          this.renderData.sort((a, b) => {
            const aItem = a?.CMIT_NM ? a.CMIT_NM : "";
            const bItem = b?.CMIT_NM ? b.CMIT_NM : "";
            return aItem.localeCompare(bItem, "ko");
          });
          this.closeSortList();
          break;
        case "REFERRAL":
          this.renderData.sort((a, b) => {
            return b.RCP_CNT - a.RCP_CNT;
          });
          this.closeSortList();
          break;
        case "PROCESSING":
          this.renderData.sort((a, b) => {
            return b.PROC_CNT - a.PROC_CNT;
          });
          this.closeSortList();
          break;
        case "UN_PROCESSING":
          this.renderData.sort((a, b) => {
            return b.RSVT_CNT - a.RSVT_CNT;
          });
          this.closeSortList();
          break;
        case "PROCESSING_RATE":
          this.renderData.sort((a, b) => {
            return b.PROC_RATE - a.PROC_RATE;
          });
          this.closeSortList();
          break;
        default:
          this.renderData = [...this.originData].sort((x, y) => {
            const indexX = sorting.indexOf(x.CMIT_NM);
            const indexY = sorting.indexOf(y.CMIT_NM);

            // a 배열에 존재하지 않는 위원회들은 최하위로 배치
            if (indexX === -1) return 1; // x가 없으면 뒤로 보내기
            if (indexY === -1) return -1; // y가 없으면 뒤로 보내기

            return indexX - indexY; // 두 위원회가 a 배열에서 나타나는 순서대로 정렬
          });
          this.closeSortList();
          break;
      }
    },
    setupChartData() {
      const labelData = this.originData
        .filter((item) => {
          return item.CMIT_NM !== "총계";
        })
        .map((item) => {
          return item.CMIT_NM.split("");
        });

      const referralData = this.originData
        .filter((item) => {
          return item.CMIT_NM !== "총계";
        })
        .map((item) => {
          return item.RCP_CNT;
        });

      const rateData = this.originData
        .filter((item) => {
          return item.CMIT_NM !== "총계";
        })
        .map((item) => {
          return item.PROC_RATE;
        });

      this.renderChart(labelData, referralData, rateData);
    },
    renderChart(labelData, referralData, rateData) {
      // Chart.js에서 필요한 모듈을 모두 등록합니다.
      Chart.register(
        CategoryScale, // 범주형 스케일
        LinearScale, // 선형 스케일
        LineElement, // 선 요소
        PointElement, // 점 요소
        Title, // 제목 플러그인
        Tooltip, // 툴팁 플러그인
        Legend, // 범례 플러그인
        LineController // LineController 추가
      );

      this.$nextTick(() => {
        const data = {
          labels: labelData,
          datasets: [
            {
              label: "회부(건)",
              data: referralData,
              borderColor: "#005aab",
              backgroundColor: "rgba(0, 90, 171, 0.2)",
              fill: true,
            },
            {
              label: "처리율(%)",
              data: rateData,
              borderColor: "#de0000",
              backgroundColor: "rgba(222, 0, 0, 0.2)",
              fill: true,
            },
          ],
        };

        const config = {
          type: "line", // line 차트 타입
          data: data,
          options: {
            responsive: window.innerWidth > 1040,
            plugins: {
              legend: {
                position: "top",
              },
              title: {
                display: false,
              },
              tooltip: {
                callbacks: {
                  title: function (context) {
                    const datasetLabel = context[0].label
                      ? context[0].label.replaceAll(",", "")
                      : "";

                    return datasetLabel;
                  },
                },
              },
            },
            scales: {
              x: {
                ticks: {
                  autoSkip: false, // 자동으로 라벨을 건너뛰기
                  maxRotation: 0, // 라벨을 세로로 회전
                  minRotation: 0, // 라벨을 세로로 회전
                },
              },
              y: {
                beginAtZero: true,
                type: "linear", // linear 스케일 사용
              },
            },
          },
        };

        const ctx = document.getElementById("chart").getContext("2d"); // canvas 요소에서 context 가져오기
        this.chartData = new Chart(ctx, config); // Chart.js로 차트 렌더링

        window.addEventListener("resize", this.checkScreenWidth);
      });
    },
    checkScreenWidth() {
      if (window.innerWidth <= 1040) {
        this.chartData.options.responsive = false;
        this.chartData.update();
      } else {
        this.chartData.options.responsive = true;
        this.chartData.update();
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenWidth);
  },
};
</script>

<style scoped>
.background-container {
  background-image: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
    url("../assets/img/standing.jpg");
  background-attachment: fixed;
  background-size: cover;
  background-position: center bottom;
  height: 600px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow-x: hidden;

  @media only screen and (max-width: 1040px) {
    background-attachment: initial;
  }
}

.about-title {
  position: relative;
  font-family: GmarketSansMedium;
  font-size: 70px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #fff;
  @media only screen and (max-width: 1040px) {
    text-align: center;
    font-size: 7vw;
  }
}

.about-title-dot {
  display: inline-block;
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: #005aab;
  border-radius: 50%;
  right: -20px;
  top: -20px;
}

.national-menu {
  position: absolute;
  bottom: 0;
  height: 80px;
  background-color: #000;
  width: 100%;
  display: flex;
  justify-content: center;
}

.national-menu-item {
  width: 511px;
  justify-content: center;
  font-family: GmarketSansMedium;
  font-size: 30px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  justify-content: center;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
}

.selected-img {
  float: right;
  margin-top: 4px;
}

.national-menu-item.active {
  background-color: #fff;
  color: #000;
  border-radius: 20px 20px 0 0;
  opacity: 1;
}

.national-content {
  margin: 100px 0 0 0;
  display: flex;
  justify-content: center;
  padding: 0 30px;
}

.canvas-wrap {
  @media only screen and (max-width: 1040px) {
    overflow-x: scroll;
  }
}

.national-content-inner {
  max-width: 1320px;
  width: 100%;

  @media only screen and (max-width: 1040px) {
    text-align: center;
  }
}

.national-table {
  width: 100%;
  border-radius: 10px;
  text-align: center;
  border-collapse: collapse;
  border-collapse: collapse;
  overflow: hidden;
  border-style: hidden;
  box-shadow: 0 0 0 1px #cacaca;

  min-width: 700px;

  & th {
    padding: 21px 0;
    border: 1px solid #cacaca;
    background-color: #005aab;
    font-family: GmarketSansMedium;
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #fff;
  }
  & td {
    min-width: 200px;
    padding: 21px 0;
    border: 1px solid #cacaca;
    font-family: GmarketSansMedium;
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #000;
    vertical-align: middle;
  }

  & td:first-child {
    width: 70px;
    min-width: 70px;
    max-width: 70px;
    word-break: break-all;
  }

  & tr td.red {
    color: #de0000;
  }

  & tr td.blue {
    color: #005aab;
  }

  @media only screen and (max-width: 1040px) {
    border-radius: 0;
  }
}

.national-table.sub-auto {
  table-layout: fixed;

  & .sky {
    background-color: #e7f4ff;

    & td {
      color: #005aab;
      width: auto !important;
    }
  }

  & td {
    width: auto;
    max-width: 10px !important;
    vertical-align: middle;
  }

  & tr td:nth-child(n + 2) {
    width: 100px;
  }

  .not {
    width: auto !important;
  }
}

.title-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 49px;

  @media only screen and (max-width: 1040px) {
    text-align: center;
    flex-direction: column;
  }
}

.national-title {
  font-family: GmarketSansMedium;
  font-size: 40px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -1px;
  text-align: left;
  color: #005aab;

  @media only screen and (max-width: 1040px) {
    margin-bottom: 54px;
  }
}

.table-wrap {
  width: 100%;
  margin: 100px 0;
}

.congressman-page-description {
  padding: 30px;
  background-color: #e0e0e0;
  margin-bottom: 100px;
}

.congressman-page-description .title {
  font-family: GmarketSansMedium;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #666;
  margin-bottom: 19px;
}
.national-blue-bar {
  width: 70px;
  height: 5px;
  display: inline-block;
  background-color: #005aab;
  margin-bottom: 19px;
  border-radius: 0 5px 5px 0;
}

.national-blue-bar.sky {
  background-color: #b0d6f8;
  margin-right: 5px;
}

.congressman-page-description .sub {
  font-family: GmarketSansMedium;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #666;
}

.round {
  width: 50px;
  height: 20px;
  display: inline-block;
  border-radius: 10px;
  vertical-align: middle;
  margin-right: 11px;
}

.round.blue {
  background-color: #005aab;
}
.round.red {
  background-color: #de0000;
}

.standing-graph-title {
  gap: 28px;
  display: flex;
  align-items: center;
  flex-direction: row;
  font-family: GmarketSansMedium;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000;

  @media only screen and (max-width: 1040px) {
    width: 100%;
    justify-content: flex-end;
  }
}

.prev-btn {
  width: 197px;
  height: 50px;
  padding: 17px 20px 18px 30px;
  border-radius: 10px;
  border: solid 1px #d8d8d8;
  background-color: #e5e5e5;
  text-align: left;
  font-family: GmarketSansMedium;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #121212;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media only screen and (max-width: 1040px) {
    width: 100%;
    border-radius: 0;
  }
}

.national-button-wrap {
  position: relative;

  @media only screen and (max-width: 1040px) {
    width: 100%;
  }
}

.national-search-list {
  line-height: 50px;
  font-family: GmarketSansMedium;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #121212;
  border: solid 1px #d8d8d8;
  padding: 0 20px 17px 31px;
  border-radius: 10px;
  display: inline-block;
  width: 197px;
  position: relative;
  cursor: pointer;
  position: absolute;
  left: 0;
  top: 49px;
  background-color: #fff;
  z-index: 5;

  & li {
    margin-top: 19px;
    cursor: pointer;
  }

  & li:hover {
    color: #005aab;
  }

  & li.selected {
    color: #005aab;
  }

  @media only screen and (max-width: 1040px) {
    width: 100%;
    text-align: left;
  }
}

.national-search-bg {
  position: absolute;
  z-index: 4;
  width: 100%;
  height: 100%;
  background-color: transparent;
  left: 0;
  top: 0;
}

.table-wrap-two {
  width: 100%;
  overflow-x: scroll;
  padding: 1px;
}
</style>
